var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 140,
    viewBox: "0 0 117 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_299_9666",
    maskUnits: "userSpaceOnUse",
    x: 0.275391,
    y: 0.730469,
    width: 116,
    height: 139,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.275391,
    y: 0.730469,
    width: 116,
    height: 139
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27539 58.7499C7.27539 30.6173 30.1622 7.73047 58.2754 7.73047C86.408 7.73047 109.275 30.6173 109.275 58.7499C109.275 79.0722 97.3657 97.2573 78.8502 105.417L61.4422 130.422C60.7234 131.452 59.5382 132.073 58.2948 132.073H58.2754C57.032 132.073 55.8468 131.452 55.128 130.422L37.7005 105.417C19.1851 97.2573 7.27539 79.0722 7.27539 58.7499Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27539 58.7499C7.27539 30.6173 30.1622 7.73047 58.2754 7.73047C86.408 7.73047 109.275 30.6173 109.275 58.7499C109.275 79.0722 97.3657 97.2573 78.8502 105.417L61.4422 130.422C60.7234 131.452 59.5382 132.073 58.2948 132.073H58.2754C57.032 132.073 55.8468 131.452 55.128 130.422L37.7005 105.417C19.1851 97.2573 7.27539 79.0722 7.27539 58.7499Z",
    fill: "#1E9C09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8502 105.417L76.0272 99.0118L74.2285 99.8045L73.1054 101.418L78.8502 105.417ZM61.4422 130.422L67.182 134.429L67.1871 134.421L61.4422 130.422ZM55.128 130.422L49.3852 134.424L49.3882 134.429L55.128 130.422ZM37.7005 105.417L43.4433 101.415L42.3205 99.8037L40.5235 99.0118L37.7005 105.417ZM58.2754 0.730469C26.2945 0.730469 0.275391 26.7531 0.275391 58.7499H14.2754C14.2754 34.4816 34.03 14.7305 58.2754 14.7305V0.730469ZM116.275 58.7499C116.275 26.7548 90.2774 0.730469 58.2754 0.730469V14.7305C82.5385 14.7305 102.275 34.4799 102.275 58.7499H116.275ZM81.6732 111.823C102.722 102.546 116.275 81.8518 116.275 58.7499H102.275C102.275 76.2925 92.009 91.9684 76.0272 99.0118L81.6732 111.823ZM67.1871 134.421L84.5951 109.417L73.1054 101.418L55.6974 126.422L67.1871 134.421ZM58.2948 139.073C61.8519 139.073 65.1689 137.312 67.182 134.429L55.7025 126.415C56.2778 125.591 57.2246 125.073 58.2948 125.073V139.073ZM58.2754 139.073H58.2948V125.073H58.2754V139.073ZM49.3882 134.429C51.4013 137.312 54.7183 139.073 58.2754 139.073V125.073C59.3457 125.073 60.2924 125.591 60.8677 126.415L49.3882 134.429ZM31.9577 109.42L49.3852 134.424L60.8708 126.419L43.4433 101.415L31.9577 109.42ZM0.275391 58.7499C0.275391 81.8518 13.8284 102.546 34.8775 111.823L40.5235 99.0118C24.5418 91.9684 14.2754 76.2925 14.2754 58.7499H0.275391Z",
    fill: "white",
    mask: "url(#path-1-outside-1_299_9666)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMarker);
export default __webpack_public_path__ + "static/media/green-marker.f6f1f0234e176f5598c7053ba6a06790.svg";
export { ForwardRef as ReactComponent };